import { Button, Dialog, Typography } from '@mui/material';
import { Box, SystemStyleObject } from '@mui/system';
import React from 'react';

import { ApplicationModal } from '@/components/organisms/ApplicationModal';

interface ConfirmationModalProps {
  readonly open: boolean;
  readonly title: string;
  readonly description: string;
  readonly confirmButtonText: string;
  readonly abortButtonText: string;

  onConfirm(): void;
  onAbort(): void;
}

export const GeneralQuestionModal: React.FC<ConfirmationModalProps> = (
  props: ConfirmationModalProps,
): React.ReactElement => {
  const { open, onConfirm, onAbort, abortButtonText, confirmButtonText, title, description } =
    props;

  return (
    <Dialog open={open} onClose={onAbort}>
      <ApplicationModal
        title={title}
        description={description}
        variant="prominent"
        onClose={onAbort}>
        <Button variant="dark" fullWidth={true} onClick={onConfirm}>
          {confirmButtonText}
        </Button>
        <Box component="a" sx={styles.customButton} onClick={onAbort}>
          <Typography variant="body2" color="text.primary">
            {abortButtonText}
          </Typography>
        </Box>
      </ApplicationModal>
    </Dialog>
  );
};

const styles: Record<string, SystemStyleObject> = {
  customButton: {
    display: 'block',
    textAlign: 'center',
    mt: 2,
    cursor: 'pointer',
  },
};
